<template lang="pug">
  v-container.View.View--CompanyLocationEdit
    template(v-if="!loading")
      v-card.pa-3
        LocationEditor(:location="location" :categories="categories" @save="edit" :saving="saving")
      HelpAlert.mt-3
    template(v-else)
      Loading
</template>

<script>
import Loading from "@/components/Loading";
import HelpAlert from "@/components/HelpAlert";
import LocationEditor from "./LocationEditor";
import Category from "@/api/Category";
import Location from "@/api/Location";

export default {
  name: "CompanyLocationEdit",
  components: { Loading, LocationEditor, HelpAlert },
  data() {
    return {
      loading: true,
      saving: false,
      location: {},
      categories: []
    };
  },

  async mounted() {
    this.loading = true;
    this.$emit("update:title", "Modifica Attività");
    this.location = await Location.get(this.$route.params.location);
    this.categories = await Category.all();
    if (this.location.openingHours) {
      for (const openingHour of this.location.openingHours) {
        if (!openingHour.slots || openingHour.slots.length == 0) {
          openingHour.closed = true;
        }
      }
    }
    this.loading = false;
  },

  methods: {
    async edit(location) {
      this.saving = true;
      try {
        await Location.update(this.location.id, location);
      } catch (error) {
        this.saving = false;
        throw error;
      }
      this.saving = false;
      this.$router.replace({
        name: "company.location.list"
      });
    }
  }
};
</script>
